async function applyDiscount(discount) {
  const cart = await fetch('/cart.js').then((res) => res.json());
  const discountCodes = cart.discount_codes?.map((code) => code.code).join(',') || '';
  return fetch('/cart/update.js', {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      discount: `${discount},${discountCodes}`,
    }),
  }).then((res) => res.json());
}

async function getDiscounts() {
  const cart = await fetch('/cart.js').then((res) => res.json());
  return cart.discount_codes?.map((code) => code.code) || [];
}

async function removeDiscount(discount) {
  const cart = await fetch('/cart.js').then((res) => res.json());
  const discountCodes =
    cart.discount_codes
      ?.map((code) => code.code)
      .filter((code) => code !== discount)
      .join(',') || '';
  return fetch('/cart/update.js', {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      discount: discountCodes,
    }),
  }).then((res) => res.json());
}
